module.exports = __webpack_public_path__ + "img/hardcore.82763fb3.png";